export const defaultLocale = 'en-US';
export const gidRegex = /^G[A-Z]{2}-[0-9A-Z]{8}$/;
export const tabQueryKey = 'tab';
